import{ useState , useEffect} from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import axios from "axios";

import React from 'react';
import logo from '../assets/mb-logono plus.png';


import {API } from "../API_CONFIG";
import { ToastEmitter } from "../components/DoctorMangement/ToastEmitter";
import { CarouselBg } from "./Carouselbg";

const BASE_URL = API;

  

export const ResetPassword = ({
  

}) =>{
    const [showResetDisabled, setShowResetDisabled] = useState(false);
    const history = useHistory();
    const [errorHelpertext, setErrorHelpertext] = useState('');
    const [newPassword, setNewPassword]= useState('');
    const [confrmPassword, setConfrimPassword] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('resettoken');


    useEffect(()=>{
      localStorage.setItem('access_token',accessToken);
    },[accessToken])

    let url = BASE_URL.infiniNode_Backend;

    const handleResetSubmit = async (e) => {
      try {
        e.preventDefault();
        e.stopPropagation();
        if (newPassword != confrmPassword) return;
        const requestBody = {
          newPassword: newPassword,
          retypePassword: confrmPassword,
          appID: 10007,
          resetToken: accessToken
        }
        const API_rl = url + '/MarketPlaceLogon/ResetPassword';

        const resp = await axios.post(API_rl, requestBody)
        if (resp.status === 200) {
          ToastEmitter("Password Reset Successfully Please Login", 'success');
          localStorage.clear();
          history.push('/login');
        }
      }
      catch(err) {
        console.log('Error in reset password ', err);
        ToastEmitter("Something Went wrong", 'error')
      }
      
      }

    const checkPassword = (e) => {  
        const password = e.target.value;
        setNewPassword(password);
        setShowResetDisabled(true);
        if (password.length < 8) {
            setErrorHelpertext('Password must be at least 8 characters long.');
            return;
          }

        if (!/[a-z]/.test(password)) {
            setErrorHelpertext('Password must contain at least one lowercase letter.');
            return;
          }
        
          // Check for at least one uppercase letter
          if (!/[A-Z]/.test(password)) {
            setErrorHelpertext('Password must contain at least one uppercase letter.');
            return;
          }
        
          // Check for at least one digit
          if (!/\d/.test(password)) {
            setErrorHelpertext('Password must contain at least one number.');
            return;
          }
        
          if (!/[!@#$%&*?]/.test(password)) {
            setErrorHelpertext('Password must contain at least one special character (!@#$%&*?).');
            return;
          }
          if(confrmPassword != newPassword) {
            setErrorHelpertext('Password is not matching with confirm password')
            return;
          }
          //reset error 
          setErrorHelpertext('');
    }

    const checkConfirmPassword= (e)=>{
        const value = e.target.value;
        setConfrimPassword(value)
        if(newPassword == value){;
            setErrorHelpertext('');
            setShowResetDisabled(false);
            return;
        }
        setErrorHelpertext('Password is not matching with confirm password');
    }


    return( 
          <div className="flex justify-center space-x-0 md:space-x-0 bg-gradient-to-l from-gray-900 via-red-900 to-gray-900">
            <div className="invisible w-0 md:visible md:w-6/12 lg:w-8/12  block m-auto ml-14 white-shadow sm:my-15 ml-0">
              <CarouselBg/>
            </div>
    
            <div className="w-full md:w-6/12 lg:w-4/12">
              <div className="flex flex-col h-screen">
                <div className="grid place-items-center my-10 lg:pl-10 sm:my-15 mr-14 my-auto">
    
                  <div className="w-11/12 sm:w-11/12 p-10 md:w-6/12 lg:w-11/12 :w-4/12 px-6 py-10 sm:px-10 sm:py-6 bg-white rounded-lg shadow-md lg:shadow-lg">
                    <div className="flex">
                      <div className="w-15-per my-auto">
                        <img src={logo} alt="logo of provider"></img>
                      </div>
                      <div className="text-lg font-semibold pl-2">
                        <span className="text-mb-blue">Medi</span>
                        <span className="text-mb-red">Buddy</span>
                        <br></br>
                            <React.Fragment>
                              <span className="text-mb-red">Provider</span>
                              <span className="text-mb-blue">Central</span>
                            </React.Fragment>
                      </div>
                    </div>
    
                    <form className="mt-10" method="submit" onSubmit={(e) => handleResetSubmit(e)}>
                      <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase"> New Password</label>
                      <input
                        id="password"
                        type="text"
                        name="password"
                        placeholder="Password"
                        autoComplete="text"
                        onChange={(e) => checkPassword(e)}
                        className="block w-full py-3 px-1 mt-2 
                        text-gray-800 appearance-none 
                        border-b-2 border-gray-100
                        focus:text-gray-500 focus:outline-none focus:border-gray-200"
                        required
                      />
    
                      <label htmlFor="password" className="block mt-2 text-xs font-semibold text-gray-600 uppercase">Confirm Password</label>
                      <input
                        id="confirmpassword"
                        type="password"
                        name="confirmpassword"
                        placeholder="Confirm Password"
                        autoComplete="current-password"
                        className="block w-full py-3 px-1 mt-2 mb-4
                        text-gray-800 appearance-none 
                        border-b-2 border-gray-100
                        focus:text-gray-500 focus:outline-none focus:border-gray-200"
                        required
                        onChange={(e)=>{
                            checkConfirmPassword(e);
                        }}
                      />
    
                      <button
                        className={"w-full py-3 mt-2 bg-mb-btn-color rounded-sm font-medium text-white uppercase cursor-pointer  focus:outline-none hover:bg-gray-700 hover:shadow-none " + (false ? 'text-white opacity-50 cursor-not-allowed' : 'text-white opacity-100 cursor-pointer')}
                        disabled={showResetDisabled}
                      >
                        Reset Password
                      </button>
                      <div className="text-center pt-5">
                        <p className="text-red-500 text-xs italic">{errorHelpertext}</p> 
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
    
    
          </div>
        );
}